import { Component, DestroyRef, ElementRef, inject, ViewChild } from '@angular/core';
import { LoadingService } from '../../../services/loading.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePipe, NgIf } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { OwnerAddComponent } from '../owner-add/owner-add.component';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxToastrService } from '../../../_services/ngx-toastr/ngx-toastr.service';
import { HttpServiceService } from '../../../services/http-service.service';
import { Select2, Select2Data } from 'ng-select2-component';
import { provideNativeDateAdapter } from '@angular/material/core';
import { LocalStorageService } from '../../../services/local-storage.service';
import { USER_PERMISSIONS } from '../../../app.constants';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-owner-details',
  imports: [OwnerOverviewComponent,MatDatepickerModule, NgIf, ReactiveFormsModule, MatFormFieldModule, MatRadioModule, FormsModule, OwnerAddComponent, BreadcrumbComponent, Select2, DatePipe],
  templateUrl: './owner-details.component.html',
  styleUrl: './owner-details.component.css',
  providers: [provideNativeDateAdapter()]
})
export class OwnerDetailsComponent {
  breadcrumbList : any;
  add_address : boolean = false;
  add_work : boolean = false;
  private userId : string ='';
  userInfo : any;
  loadingService = inject(LoadingService);
  addressForm! : FormGroup;
  @ViewChild(OwnerAddComponent) owner!: OwnerAddComponent;
  private routeSubscription? : Subscription;
  private getUserDetailsSubscription?: Subscription;
  private getCountriesSubscription?: Subscription;
  private getStatesSubscription?: Subscription;
  private getCitiesSubscription?: Subscription;
  private updateOwnerAddressSubscription?:Subscription;
  personal_info: any;
  countries: Select2Data = [];
  states: Select2Data = [];
  cities: Select2Data = [];
  selected_country: string | undefined = '';
  selected_state: string | undefined = '';
  selected_city: string | undefined = '';
  profileDetails : any;
  workForm! : FormGroup;
  addProperty? : string;
  private authService = inject(LocalStorageService);
  @ViewChild('add_address_popup') addAddressCanvas!: ElementRef;
  private addAddressInstance: Offcanvas | null = null;
  @ViewChild('add_work_popup') addWorkCanvas!: ElementRef;
  private addWorkInstance: Offcanvas | null = null;
  private queryParamsData : any;
  private queryParamsSubsscription? : Subscription;
  private destroyRef = inject(DestroyRef);

  
  constructor(private fb: FormBuilder, private route: ActivatedRoute, private alertService: NgxToastrService, private httpService : HttpServiceService, private router: Router){
    this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = { 
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Overview',
        breadcrumb_url : '/admin/'+ (userType == "owner" ? "owners" : "tenants") 
      };      
    });
    this.queryParamsSubsscription = this.route.queryParams.subscribe((data: any)=> {
      this.queryParamsData = data;
    });
    this.addressForm = this.fb.group({
      address: ['', [Validators.required]],
      country: [null, [Validators.required]],
      city: [null, [Validators.required]],
      state : [null, [Validators.required]],
      postal_code : ['', [Validators.required]]
    });

    this.workForm = this.fb.group({
      company_name: ['' ,[Validators.required]],
      company_address: ['', [Validators.required]],
      company_phone: [''],
      company_email: [''],
      designation : [''],
      department : [''],
      work_start_date : [''],
      work_end_date : [''],
      work_experience : [''],
      work_location : [''],
      monthly_income : ['']
    });    

  }

  ngOnInit(){
    this.addressForm.get('country')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
      const selected = this.countries.find((opt: any) => opt.value == id);
      this.selected_country = selected?.label;
    });

    this.addressForm.get('state')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
      const selected = this.states.find((opt: any) => opt.value == id);
      this.selected_state = selected?.label;
    });

    this.addressForm.get('city')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
      const selected = this.cities.find((opt: any) => opt.value == id);
      this.selected_city = selected?.label;
    });
  }

  ngAfterViewInit() {
      setTimeout(() => {
        const searchCanvasElement = this.addAddressCanvas?.nativeElement;
        if (searchCanvasElement) {
          this.addAddressInstance = Offcanvas.getOrCreateInstance(searchCanvasElement, {
            backdrop: 'static',
            keyboard: false,
          });
        }
        
        const WorkCanvasElement = this.addWorkCanvas?.nativeElement;
        if (WorkCanvasElement) {
          this.addWorkInstance = Offcanvas.getOrCreateInstance(WorkCanvasElement, {
            backdrop: 'static',
            keyboard: false,
          });
        }
      });
    }

  goBackToList(event : any){    
    this.router.navigate([this.breadcrumbList.breadcrumb_url], {
      queryParams : this.queryParamsData
    });
  }

  getUserDetailsById(){
    this.getUserDetailsSubscription = this.httpService.getUser(this.userId).subscribe({
      next : (response) => {
        this.userInfo = response.data;
        this.personal_info = response.data?.personal_info ?? {};
      }
    })
  }

  getUserDetails(data : any){
    this.userInfo = data;
    this.personal_info = data?.personal_info ?? {};
  }

  toggleAdress(){
    this.add_address = !this.add_address;
    if(this.add_address){
      this.getCountries();
      this.addressForm.patchValue(this.userInfo?.address_info);
      if (this.addAddressInstance) {
         this.addAddressInstance.show();
      }
    }
  }

  addressCancel(){
    this.addressForm.reset();
    this.toggleAdress();
    if (this.addAddressInstance) {
      this.addAddressInstance.hide();
    }
  }  
  

  onAddressSubmit(){
    if(this.addressForm.valid){      
      let addressObj : any = {};
      Object.keys(this.addressForm.controls).forEach((key) => {
        let value = this.addressForm.get(key)?.value;
        if(key == 'country'){
          value = this.selected_country ?? "";
        }else if(key == 'state'){
          value = this.selected_state ?? "";
        }else if(key == 'city'){
          value = this.selected_city ?? "";
        }
        if(value) addressObj[key] = value;
      }); 
      this.updateOwnerAddressSubscription = this.httpService.editUser(addressObj, this.userId).subscribe({
        next : (response) => {
          this.addressCancel();
          this.getUserDetailsById();
          this.alertService.success(response.message, "toast-top-right");
        }
      })
    }
  }
  
  toggleSearch(){
    //this.tenant.toggleSearch();
 }

 updateOwner(){
  this.owner.editUser(this.userInfo);
 }

 ownerUpdatedNotification(event : Event){
   this.getUserDetailsById();
 }

 getCountries(){
    this.getCountriesSubscription = this.httpService.getLocations('country').subscribe({
      next : (resp) => { 
        let country = resp.data?.find((c: { name: any; }) => c.name == this.userInfo?.address_info?.country);
        for(let country of resp.data){
          this.countries.push(
            {
              value: country.id,
              label: country.name,
              data: { name: country.name }
            }
          )
      }
      this.addressForm?.patchValue({
        country: country?.id
      }); 
      this.getStates();
      },
      error : (error) => {

      }
    });
  }

  getStates(){  
    let countryId = this.addressForm?.get('country')?.value;
    if(countryId){
      this.states = [];
      this.getStatesSubscription = this.httpService.getLocations('state','&countryId='+countryId).subscribe({
        next : (resp) => {  
          let state = resp.data?.find((c: { name: any; }) => c.name == this.userInfo?.address_info?.state);      
          for (let state of resp.data) {
            this.states.push(
              {
                value: state.id,
                label: state.name,
                data: { name: state.name }
              }
            )
          }
          this.addressForm?.patchValue({
            state: state?.id
          });
          this.getCities();
        },
        error : (error) => {
  
        }
      });
    }
  }

  getCities(){
    let stateId = this.addressForm?.get('state')?.value;
    if(stateId){
      this.cities = [];
      this.getCitiesSubscription = this.httpService.getLocations('city','&stateId='+stateId).subscribe({
        next : (resp) => {   
          let city = resp.data?.find((c: { name: any; }) => c.name == this.userInfo?.address_info?.city);     
          for(let city of resp.data){
            this.cities.push(
              {
                value: city.id,
                label: city.name,
                data: { name: city.name }
              }
            )
          } 
          this.addressForm?.patchValue({
            city: city?.id
          });
        },
        error : (error) => {
  
        }
      });
    } 
  }

  toggleWork(){
    this.add_work = !this.add_work;
    if(this.add_work) {
      this.workForm.patchValue(this.userInfo?.work_info);
      if (this.addWorkInstance) {
        this.addWorkInstance.show();
      }
    }
  }

  workCancel(){
    this.toggleWork();
    this.workForm.reset();
    if (this.addWorkInstance) {
      this.addWorkInstance.hide();
    }
  }

  onWorkSubmit(){
   if(this.workForm.valid){
    const propertyUpdateObj = Object.fromEntries(
      Object.entries(this.workForm.value).filter(([_, v]) => v !== null && v !== '')
    ) as unknown as any;
    this.updateOwnerAddressSubscription = this.httpService.editUser(propertyUpdateObj, this.userId).subscribe({
        next : (response) => {
          this.workCancel();
          this.getUserDetailsById();
          this.alertService.success(response.message, "toast-top-right");
        }
      });    
   }
  }

 ngOnDestroy(){
  this.routeSubscription?.unsubscribe();
  this.getUserDetailsSubscription?.unsubscribe();
  this.getCountriesSubscription?.unsubscribe();
  this.getStatesSubscription?.unsubscribe();
  this.getCitiesSubscription?.unsubscribe();
  this.updateOwnerAddressSubscription?.unsubscribe();
  this.queryParamsSubsscription?.unsubscribe();
 }

 get checkUserPersonalInfoUpdate(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_PERSONAL_UPDATE);
  }

  get checkUserAddressUpdate(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_ADDRESS_UPDATE);
  }

  get checkUserWorkView(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_WORK_VIEW);
  }

  get checkUserWorkUpdate(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_WORK_UPDATE);
  }

}
